import { SecondaryButton } from '@designsforhealth/dfh-react-components'
import styled from 'styled-components'

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px 32px 24px 32px;
`

export const ModalHeader = styled.div`
  background: ${({ theme }) => theme.colors.brandBlue.main};
  width: 100%;
  border-radius: 4px 4px 0 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
`

const ModalBoldText = styled.h3`
  font-family: ${({ theme }) => theme.fontFamilies.gotham};
  font-weight: 600;
`

export const ModalTitle = styled(ModalBoldText)`
  color: ${({ theme }) => theme.colors.grayscale.white};
  font-size: 20px;
  margin: auto 0 auto 0;
`

export const ModalCloseButton = styled.button`
  height: 38px;
  width: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`

export const ModalNoButton = styled(SecondaryButton)<{
  text?: string
  onClick?: React.MouseEventHandler<HTMLButtonElement>
}>`
  width: 190px;
  border: 1px solid black;
  margin: 10px 10px 0 10px;
  white-space: nowrap;
  @media (min-width: 600px) {
    width: 130px;
  }
`

export const ModalYesButton = styled(ModalNoButton)<{
  text?: string
  onClick?: React.MouseEventHandler<HTMLButtonElement>
}>`
  background: ${({ theme }) => theme.colors.brand.categoryRed};
  border: none;
  color: ${({ theme }) => theme.colors.brand.white};
  @media (min-width: 600px) {
    width: 190px;
  }
`

export const ModalText = styled.p`
  color: ${({ theme }) => theme.colors.grayscale.black};
  font-family: ${({ theme }) => theme.fontFamilies.gotham};
  margin: 0 0 20px 0;
`

export const ModalButtonBox = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 auto 0 auto;
  @media (min-width: 600px) {
    flex-direction: row;
  }
`
